import { useSelector } from 'react-redux';

type Feature = keyof Store.Group.Features;

export const useHasGroupFeature = (feature: Feature) => {
  const features = useSelector((store: Store.State) => store.group.features);
  return !!features[feature];
};